module.exports = __webpack_public_path__ + "img/banner3.77494b41.png";